import { Link } from 'react-router-dom';
import {
  FaLinkedinIn,
  FaTwitter,
  FaEnvelope,
  FaYoutube,
  FaInstagram,
  FaFacebookF
} from 'react-icons/fa';

export const Footer = () => {
  const navigation = {
    company: [
      { name: 'About', href: '/about' },
      { name: 'Case Studies', href: '/case-studies' },
      { name: 'Team', href: '/team' },
      { name: 'Blogs', href: '/resources' },
      { name: 'Contact Us', href: '/contact' }
    ],
    services: [
      { name: 'GEO/AIO Optimization', href: '/services/geo-aio' },
      { name: 'AI Ads', href: '/services/ai-ads' },
      { name: 'AI Agents', href: '/services/ai-agents' },
      { name: 'Integrations', href: '/integrations' },
      { name: 'Free Audit', href: '/free-audit' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' }
    ]
  };

  return (
    <footer className="bg-[#081944] text-secondary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1fr] gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img
                src="/assets/logo-dark-mode.png"
                alt="Evolution GEO"
                className="h-8 w-auto"
                loading="lazy"
              />
            </Link>
            <p className="text-sm text-secondary-foreground/70 mb-4">
              Helping brands become the default answer in AI-driven search.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-md border border-secondary-foreground/20 bg-secondary/20 flex items-center justify-center text-secondary-foreground/80 hover:text-accent hover:border-accent transition-colors"
              >
                <FaLinkedinIn size={16} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-md border border-secondary-foreground/20 bg-secondary/20 flex items-center justify-center text-secondary-foreground/80 hover:text-accent hover:border-accent transition-colors"
              >
                <FaTwitter size={16} />
              </a>
              <a
                href="mailto:hello@evolutiongeo.com"
                className="w-9 h-9 rounded-md border border-secondary-foreground/20 bg-secondary/20 flex items-center justify-center text-secondary-foreground/80 hover:text-accent hover:border-accent transition-colors"
              >
                <FaEnvelope size={16} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-md border border-secondary-foreground/20 bg-secondary/20 flex items-center justify-center text-secondary-foreground/80 hover:text-accent hover:border-accent transition-colors"
              >
                <FaYoutube size={16} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-md border border-secondary-foreground/20 bg-secondary/20 flex items-center justify-center text-secondary-foreground/80 hover:text-accent hover:border-accent transition-colors"
              >
                <FaInstagram size={16} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-md border border-secondary-foreground/20 bg-secondary/20 flex items-center justify-center text-secondary-foreground/80 hover:text-accent hover:border-accent transition-colors"
              >
                <FaFacebookF size={16} />
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-display font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              {navigation.company.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-sm text-secondary-foreground/70 hover:text-accent transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-display font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              {navigation.services.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-sm text-secondary-foreground/70 hover:text-accent transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-display font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              {navigation.legal.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-sm text-secondary-foreground/70 hover:text-accent transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <p className="text-xs text-secondary-foreground/50">
                Certified in AIO &amp; GEO by IBM, Google &amp; Microsoft
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-secondary-foreground/10 flex flex-col md:flex-row items-center md:items-center justify-between gap-4">
          <p className="text-sm text-secondary-foreground/50">
            © {new Date().getFullYear()} Evolution GEO. All rights reserved.
          </p>
          <a
            href="/sitemap.xml"
            className="text-sm text-secondary-foreground/70 hover:text-accent transition-colors"
          >
            SiteMap
          </a>
        </div>
      </div>
    </footer>
  );
};

